import { useEffect } from 'react';

/**
 * Scrolls to top when the *displayed* route changes — not when the URL
 * updates. During wave transitions, pass displayLocation.pathname so the
 * jump happens under the seal.
 */
const ScrollToTop = ({ pathname }) => {
  useEffect(() => {
    if (pathname == null) return;

    const originalScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = originalScrollBehavior;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
